import styled from 'styled-components'
import { Input } from 'antd'
import { greys, borderRadius } from 'assets/themes/theme-default'
import { calculateAlphaColor } from 'core/utils/colors'

const { Search } = Input

export const antSearchStyled = styled(Search)`
  &&& {
    color: ${greys.dark1};
    .ant-input {
      :hover {
        border-color: ${props => props.theme.colors.color1.bg};
      }
      :focus {
        border-color: ${props => props.theme.colors.color1.bg};
        box-shadow: 0 0 0 2px ${props => calculateAlphaColor(props.theme.colors.color1.bg, 0.5)};
      }
      :active {
        border-color: ${props => props.theme.colors.color1.bg};
        box-shadow: 0 0 0 2px ${props => calculateAlphaColor(props.theme.colors.color1.bg, 0.5)};
      }
    }
  }
`

const AntInputStyled = styled(Input)`
  &&& {
    color: ${greys.dark1};
    border-radius: ${borderRadius.sm};
    border-color: ${greys.dark4};
    :hover {
      border-color: ${props => props.theme.colors.color1.bg};
    }
    :focus {
      border-color: ${props => props.theme.colors.color1.bg};
      box-shadow: 0 0 0 2px ${props => calculateAlphaColor(props.theme.colors.color1.bg, 0.5)};
    }
    :active {
      border-color: ${props => props.theme.colors.color1.bg};
      box-shadow: 0 0 0 2px ${props => calculateAlphaColor(props.theme.colors.color1.bg, 0.5)};
    }
    .ant-input {
      border-radius: ${borderRadius.base};
      border-color: ${greys.dark4};
      :hover {
        border-color: ${props => props.theme.colors.color1.bg};
      }
      :focus {
        border-color: ${props => props.theme.colors.color1.bg};
        box-shadow: 0 0 0 2px ${props => calculateAlphaColor(props.theme.colors.color1.bg, 0.5)};
      }
      :active {
        border-color: ${props => props.theme.colors.color1.bg};
        box-shadow: 0 0 0 2px ${props => calculateAlphaColor(props.theme.colors.color1.bg, 0.5)};
      }
    }
  }
`

export default AntInputStyled
